import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { Button, Text } from 'react-orange-ui';
import styled from 'styled-components';

import Title from '../../Title/Title';
import ContactList from './ContactList';
import OLink from '../../../orange-ui/components/Link/OLink';
import Spinner from '../../Spinner/Spinner';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

const WrapperSpinner = styled.div`
  height: 5em;
  width: 5em;
  transform: translateY(50%);
`;

class ConfirmView extends Component {
  /**
   * Reload contacts with non obfuscated data on mount
   */
  componentDidMount() {
    const { reloadContacts } = this.props;

    reloadContacts();
  }

  /**
   * Redirect user to the auth service with the redirect url received from API when exists
   * @param e
   */
  handleAuth = (e) => {
    e.preventDefault();
    const { quitApp } = this.props;

    TagService.sendAction('auth');
    quitApp();
  };

  render() {
    const { contacts, isFetching, webViewFlag } = this.props;

    let contactsEl;

    if (contacts.length > 0) {
      contactsEl = <ContactList contacts={contacts} />;
    }

    return (
      <div id="confirm-form">
        <Row>
          <Col sm={12}>
            <Title id="confirmation" label={WordingService.getWording('title', 'passwordIsSaved')} icon="tick" size={32} color="green" />
            <br />
            <Text id="confirmation-text">
              {WordingService.getWording('caption', 'helpNewPassword1')}
              <OLink id="link-assistance-devices" href={window.reactAppEnv.href.helpMessaging} newTab disabled={webViewFlag} onClick={() => TagService.sendAction('helpMessaging')}>
                {WordingService.getWording('url', 'update')}
              </OLink>
              {WordingService.getWording('caption', 'helpNewPassword2')}
            </Text>
            { isFetching ? (
              <WrapperSpinner>
                <Spinner />
              </WrapperSpinner>
            ) : contactsEl}
            <Text id="change-password-help">
              {WordingService.getWording('caption', 'helpToChangePassword')}
              <OLink id="link-orange-account" href={window.reactAppEnv.href.account} newTab disabled={webViewFlag} onClick={() => TagService.sendAction('account')}>
                {WordingService.getWording('url', 'yourAccount')}
              </OLink>
              .
            </Text>
            <br />
            <Text id="password-best-practices">
              {WordingService.getWording('caption', 'phishing')}
              <OLink id="link-phishing-info" href={window.reactAppEnv.href.phishingInfo} newTab shouldBeHidden={webViewFlag} onClick={() => TagService.sendAction('phishingInfo')}>
                {WordingService.getWording('url', 'phishing')}
              </OLink>
            </Text>
            <br />
            <Button id="auth-button" type="fill" onClick={this.handleAuth}>
              {WordingService.getWording('button', 'login')}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

ConfirmView.defaultProps = {
  webViewFlag: false,
  contacts: [],
  isFetching: true,
};

ConfirmView.propTypes = {
  /** Action to reload all contacts ways with obfuscated data */
  reloadContacts: PropTypes.func.isRequired,
  /** Action to quit the app */
  quitApp: PropTypes.func.isRequired,
  /** All user contact ways */
  contacts: PropTypes.arrayOf(PropTypes.shape({
    contactId: PropTypes.string,
    contactView: PropTypes.string,
    contactType: PropTypes.string,
    contactValidity: PropTypes.string,
    contactData: PropTypes.string,
  })),
  /** Boolean indicates when fetching contact data */
  isFetching: PropTypes.bool,
  /** Flag to know if the app is in webView Mode */
  webViewFlag: PropTypes.bool,
};


export default ConfirmView;
